import { createFileRoute } from "@tanstack/react-router";
import { guardEmployeeSurface } from "./-employee-surfaces";
import Page from "@/app/employee/[id]/documents/page";

export const Route = createFileRoute("/employee/$id/documents")({
  beforeLoad: ({ params }) => guardEmployeeSurface("documents", params.id),
  component: Page,
});
